// extracted by mini-css-extract-plugin
export var field = "textarea-module--field--46756";
export var fieldDarkTheme = "textarea-module--field-dark-theme--9dbf4";